/**
 * src/web/components/invite-members-dialog.jsx
 * メンバー招待ダイアログ
 */

import React from 'react'
import connect from '../../connects/invite-members-dialog'
import { translate } from 'react-i18next'
import Dialog from 'react-toolbox/lib/dialog'
import Button from 'react-toolbox/lib/button'
import Checkbox from 'react-toolbox/lib/checkbox'
import { track } from '../../helpers/analytics'
import inviteIconTheme from './themes/invite-icon.css'
import inviteMembersTheme from './themes/invite-members-dialog.css'
import config from '../../config'

class InviteMembersDialog extends React.Component {
  state = { already_display: false }

  openURL = ()=> {
    this.onClose()
    track('invite_users')
  }

  onChangeCheckBox = ()=>{
    this.props.setIsHiddenToStore( !this.props.ui.isHidden )
    this.props.updateUI({ isHidden: !this.props.ui.isHidden })
  }

  onClose = ()=> {
    this.props.updateUI({ active: false })
    this.props.onHide()
  }

  render() {
    const {
      t,
      ui,
      updateUI,
      usersAdminUrl,
      registrationUrl,
      already_display,
      onHide,
    } = this.props

    return (
      <Dialog active={ !already_display && ui.active }
        theme={inviteMembersTheme}
        type='small'
        onEscKeyDown={this.onClose}
        onOverlayClick={this.onClose}
        title={t('label:ウェルカムメッセージ')}
        actions={[
          { label: t('label:閉じる'), onClick: this.onClose, raised: true }
        ]} >
        <div className={inviteMembersTheme.subTitle}>{t('label:無料ウェブ説明')}</div>
        <div>{t('label:ウェブ説明詳細')}</div>
        <div className={inviteMembersTheme.image}>
          <img className={inviteIconTheme.image} />
        </div>
        <div className={inviteMembersTheme.inviteButton}>
          <Button 
            className={inviteMembersTheme.inviteMenu} 
            onClick={this.openURL}
            href={config.timerexUrl}
            primary raised
            target='_blank'>
              {t('label:ウェブ説明予約(WEB版)')}
          </Button>
        </div>
      </Dialog>
    )
  }
}

export default connect(InviteMembersDialog)


// WEBPACK FOOTER //
// ./src/web/components/invite-members-dialog.jsx